import { ActionTree, ActionContext } from 'vuex';

import { subsClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { PlansStateI } from './state';

export const actions: ActionTree<PlansStateI, RootStateI> = {
  async getByServiceName(
    context: ActionContext<PlansStateI, RootStateI>,
    payload: string,
  ): Promise<void> {
    const { data } = await subsClient.get(`/api/plans/get?service_name=${payload}`);
    context.commit('setPlans', snakeToCamel(data));
    return data;
  },
  async enrolltrial(
    context: ActionContext<PlansStateI, RootStateI>,
    payload: { serviceName: string; planId: string },
  ): Promise<void> {
    const { data } = await subsClient.post(
      `/api/plans/enrolltrial?service_name=${payload.serviceName}&plan_id=${payload.planId}`,
    );
    console.log('enrolltrial', data);
    return data;
  },
};
